module.exports = __webpack_public_path__ + "images/marketing/peeps/jody_ferry.jpg";